var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.727 9.31338C17.3478 8.91186 16.7149 8.89378 16.3134 9.27299L12 13.2912L7.68662 9.27299C7.2851 8.89378 6.6522 8.91186 6.27299 9.31338C5.89377 9.7149 5.91186 10.3478 6.31337 10.727L11.3134 15.3937C11.6988 15.7577 12.3012 15.7577 12.6866 15.3937L17.6866 10.727C18.0881 10.3478 18.1062 9.7149 17.727 9.31338Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95
  })));
};
export default SvgDropdown;